import { Address } from '@40seas/models';
import { BusinessMatch } from '@40seas/entities/match';
import { AmlInfo } from '@40seas/entities/aiprize';

export enum Provider {
    Allianz = 'allianz',
    Atradius = 'atradius',
    CreditSafe = 'creditsafe',
    WiserFunding = 'wiserfunding',
    Aiprize = 'aiprize',
}

export interface ProviderData {
    legalName?: string;
    address?: Address;
    registrationNumber?: string;
    dunsNumber?: string;
    vatNumber?: string;
    businessStartDate?: Date;
    emailAddresses?: string[];
    amlInfo?: AmlInfo;
    website?: string;
    businessType?: string;
}

export interface ProviderResult {
    provider: Provider;
    data: ProviderData;
    match: BusinessMatch;
    confidence: number;
    status?: 'pending' | 'ready';
}
